import { Stack, Typography } from '@mui/material';
import { MultiSectionDigitalClock, TimeField } from '@mui/x-date-pickers';

import { type Dayjs } from '@/utils/dayjs';

export const TimePicker = ({
  value,
  setValue,
}: {
  value: Dayjs;
  setValue: (value: Dayjs) => void;
}) => {
  return (
    <Stack className='p-[24px] w-[308px] h-[348px]' gap='24px'>
      <Stack direction='row' justifyContent='space-between'>
        <Typography variant='subtitle1' className='mt-[4px]'>
          Backup start time
        </Typography>
        <TimeField
          ampm={false}
          value={value}
          onChange={(value) => {
            if (value) {
              setValue(value);
            }
          }}
          sx={{
            width: '80px',

            '& .MuiInputBase-root': {
              padding: 0,
              fontSize: '13px',
            },

            '& .MuiOutlinedInput-input': {
              padding: '4px 12px',
            },

            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid var(--mui-palette-primary-main)',
            },
          }}
        />
      </Stack>
      <MultiSectionDigitalClock
        autoFocus={false}
        ampm={false}
        minutesStep={1}
        timeSteps={{ minutes: 1 }}
        value={value}
        onChange={(value) => {
          if (value) {
            setValue(value);
          }
        }}
        sx={{
          flexGrow: 1,
          border: '1px solid var(--mui-palette-divider)',

          '& .MuiList-root': {
            flexGrow: 1,
            width: '50%',
            padding: '4px',
            maxHeight: '100%',
          },

          '& .MuiMenuItem-root': {
            padding: '12px 8px',
            width: '100%',
            margin: 0,
            justifyContent: 'start',

            '&:hover': {
              backgroundColor: 'var(--mui-palette-primary-dark)',
            },
          },

          '& .Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-primary-dark) !important',
          },

          '& .Mui-focusVisible.Mui-selected': {
            backgroundColor: 'var(--mui-palette-primary-main) !important',
          },
        }}
      />
    </Stack>
  );
};
